import { SaveTranscriptProps } from "src/types/data";
import Api from "src/services/api"
import ApiPy from "src/services/apipy"
import { getSession } from "src/services/cognito";
import { result } from "lodash";



const getUserDetail = async () => {
  try {
    const response = await Api.callProtectedApi('POST', `/getUserDetailsByToken`, {
      data: {}
    });
    
    return response;
  } catch (err) {
    throw new Error(err.message)
  }
};

const updateProfile = async (userId, name) => {
  try {
    const response = await Api.callProtectedApi('POST', `/updateUser`,{
      params: { 
        userId,
        userName: name
      }
    });
    
    return response;
  } catch (err) {
    throw new Error(err.message)
  }
};

const qcastQuery = async (userId, callback) => {
  try {
    const response = await Api.callProtectedApi('GET', `/getQcastDashboard`,{
      params: { userId }
    });
    
    callback(response);
  } catch (err) {
    callback({
      id: 500,
      msg: err.message,
    });
  }
};
  
const qcastOrgQuery2 = async (userId,organisationId="25618") => {
  try {
    const response = await Api.callProtectedApi('GET', `/getQcastDashboard?userId=${userId}&organisationId=${organisationId}`);
    
    return response;
  } catch (err) {
    console.error('Error saving Qcast:', err);
    throw err; // Re-throw to allow handling by caller
  }
};
const qcastOrgQuery = async (userId,organisationId, callback) => {
  try {
    const response = await Api.callProtectedApi('GET', `/getQcastDashboard?userId=${userId}&organisationId=${organisationId}`);
    
    callback(response);
  } catch (err) {
    callback({
      id: 500,
      msg: err.message,
    });
  }
};
const listQcastsByOrganisationApiKey = async (orgApiKey) => {
  try {
    const response = await Api.callProtectedApi('GET', '/listQcastsByOrganisationApiKey', {
      headers: {
        "x-Api-key": orgApiKey,
      }
    });
    return response;
  } catch (err) {
    throw new Error(err);
  }
};

const getPluginMode = async (orgApiKey) => {
  try {
    const response = await Api.callProtectedApi('GET', '/getOrganisationPluginMode', {
      headers: {
        "x-Api-key": orgApiKey,
      }
    });
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};

const saveQcast = async (qcastDetails) => {
  
  try {
    const { 
      userId, 
      profileName, 
      Status, 
      title, 
      tag, 
      organisationId,
      listOfVideo,
      preview_video_id,
      outrVideo,
      cover_photo 
    } = qcastDetails;

    const formData = new FormData();
    
    // Upload all videos in parallel
    const uploadedVideos = await Promise.all(
      listOfVideo.map(vid => uploadMedia(vid.file, "video/mp4", userId))
    );

    // Extract successful video uploads
    const videoIds = uploadedVideos.map(result => {
      if (result.id !== 200) throw new Error(result.msg);
      return result.data;
    });

    formData.append("listOfVideo", videoIds.join(","));

    // Upload preview video if exists
    let previewVideoId = "";
    if (preview_video_id) {
      const previewResult = await uploadMedia(preview_video_id, "video/mp4", userId);
      if (previewResult.id !== 200) throw new Error(previewResult.msg);
      previewVideoId = previewResult.data;
    }
    formData.append("preview_video_id", previewVideoId);

    // Upload outro video if exists
    let outroVideoId = "";
    if (outrVideo) {
      const outroResult = await uploadMedia(outrVideo, "video/mp4", userId);
      if (outroResult.id !== 200) throw new Error(outroResult.msg);
      outroVideoId = outroResult.data;
    }
    formData.append("outrVideo", outroVideoId);

    // Handle cover photo upload
    let coverPhotoId;
    if (cover_photo) {
      const coverResult = await uploadMedia(cover_photo, "image/png", userId);
      if (coverResult.id !== 200) throw new Error(coverResult.msg);
      coverPhotoId = coverResult.data;
    } else {
      coverPhotoId = videoIds[0]; // Use first video ID as cover if no photo provided
    }
    formData.append("cover_photo", coverPhotoId);

    // Append remaining form data
    const formFields = {
      title,
      tag,
      profileName,
      Status,
      userId,
      organisationId
    };
    
    Object.entries(formFields).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // Make the final API call
    const response = await Api.callProtectedApi('POST', '/addQcastForPlugin', {
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    return response;

  } catch (error) {
    console.error('Error saving Qcast:', error);
    throw error; // Re-throw to allow handling by caller
  }
};

const urltoFile=(url, mimeType)=> {
  if (mimeType.split("/")[0] === "video") {
    return new Promise((resolve) => {
      let createdFile = new File([url], "qcast.mp4", { type: mimeType });
      resolve(createdFile);
    });
  } else if (mimeType.split("/")[0] === "image") {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], "qcast.png", { type: mimeType });
      });
  }
}

const mergeQuestionAndAnswerLists = (
  questionList: any[], 
  answerList: any[]
) => {
let result:any[]=[];
answerList.forEach(v=>{
  result.push({
    question:questionList[v.index],
    answer:v.responseVideoResult,
    totalResponseDuration: "30",
      actualResponseDuration: parseInt(v.duration)||"1"

  })
})
return result;
  /* return questionList.map((question, index) => {
    return{
    question,
    answer: Array.isArray(answerList) && answerList[index] !== undefined 
      ? answerList[index] 
      : (Array.isArray(answerList) ? "" : answerList),
      totalResponseDuration: "1",
      actualResponseDuration: "1"
  }}); */
};





const uploadMedia = async (file, mimeType, userId) => {
  const accessToken: any = await getSession();
  try {
    const myFile: any = await urltoFile(file, mimeType);
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("mediaFile", myFile);

    const response = await Api.callProtectedApi(
      "post",
      "/uploadGetMediaID",
      {
        data: formData,
        headers: {
          Authorization: "Bearer " + accessToken.idToken.jwtToken,
        "Content-Type": "multipart/form-data",
        }
      }
    );

    return response.data;
  } catch (err) {
    throw new Error(err);
  }
};

const getQcastByIdAndOrganisationApiKey = async ( qcastId, accessToken) => {

  try {
    const response = await Api.callProtectedApi('GET', '/getQcastByIdAndOrganisationApiKey', {
      params: {
        qcastId,
      },
      headers: {
        "x-Api-key": accessToken,
      }
    });
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};

const saveResponse = async (responseDetails: any) => {
  try {
    const {
      userId,
      qcastId,
      video,
      questionList,
      title,
      tag,
      answerIndex,
      transcriptions,
      thumbnails,
      thumbnail,
      askSignUp,
	    isPlugin
    } = responseDetails;
    
    
    // Prepare initial request body
    let requestBody: any = {
      userId,
      qcastId,
      title,
      tag,
      askSignUp,
      isPlugin,
      answerTimeIndex: answerIndex.length > 0 ? answerIndex.join(";") : null,
    };

    // Upload response video
    let answerList: any[]=[];
    for(let ln in video){
      const responseVideoResult = await uploadMedia(video[ln].video, "video/mp4", userId);
      if (!responseVideoResult) {
        throw new Error("Unable to uload video.");
      }
      answerList.push({...video[ln],responseVideoResult});
    }
    

    

    // Post Transcripts
  /*   if (transcriptions && Object.keys(transcriptions).length > 0) {
      const transcripts: any = Array.from({ length: answerList.length }).map((_, index) => ({
        videoId: answerList[index],
        transcript: transcriptions[index]
      }));
      const response = await saveQcastResponseVideoTranscript(transcripts);
    }
 */


    // Merge question and answer lists
    requestBody.responseVideos = mergeQuestionAndAnswerLists(
      questionList,
      answerList
    );

    // Handle thumbnail upload
    let thumbUrl="";
    if(thumbnails){
      thumbUrl = await uploadMedia(thumbnails , "image/png", userId);
      if (!thumbUrl) {
        throw new Error("Unable to upload thumbnail.");
      }
    }
    if(thumbUrl){
      requestBody.responseThumbnail = thumbUrl;
    }else{
      requestBody.responseThumbnail = thumbnail;
    }
    

    
    // Save interview
    const response = await Api.callProtectedApi('POST', '/saveQcastInterview', {
      data: requestBody
    });

    return response;

  } catch (error) {
    if (error.response && error.response.status === 400) {
      return {
        id: 200,
        msg: "Response saved successfuly."
      }
    } else if (error.request) {
      return {
        id: 400,
        msg: "No response from the server."
      }
    } else {
      return {
        id: 500,
        msg: error.message,
      };
    }
  }
};

const updateResponderDetails = async (details: any) => {
  try {
    const reqBody: any = {
      name: details.name,
      email: details.email
    }
    const response = await Api.callProtectedApi('PUT', `/updateResponderDetails?interviewId=${details.interviewId}`, {
      data: reqBody
    });
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};

const getQcastDeepCopy = async (qcastId: string, userId: string) => {
  try {
    const response = await Api.callProtectedApi('GET', '/getQcastDeepCopy', {
      params: {
        userId,
        qcastId
      }
    });
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};

const getQcastDeepCopyForPlayer = async (qcastId: string, accessCode: string) => {
  try {
    return await Api.callProtectedApi('POST', '/getQcastDeepCopyForPlayer', {
      data: {
        qcastId,
        accessCode
      }
    });
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};

const getQcastBtId = async (qcastId: string) => {
  try {
    const response = await Api.callProtectedApi('GET', '/getQcastById', {
      params: {
        qcastId
      }
    });
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};
const getTranscription = async (qcastId: string) => {
  try {
    const response = await ApiPy.callProtectedApi('GET', `/transcriptions/qcast/${qcastId}`);
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};
const getTranscriptionInterview = async (interviewId: string) => {
  try {
    const response = await ApiPy.callProtectedApi('GET', `/transcriptions/interview/${interviewId}`);
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};
const getResponseDeepCopy = async (userId, interviewId) => {
  try {
    
    const response = await Api.callProtectedApi('POST', '/getQcastInterview', {
      params: {
        userId,
        interviewId,
      }
    });

    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};

const getQcastResponses = async (userId, qcastId, accessToken) =>{
  try{
    const response = await Api.callProtectedApi('GET', '/getVideoResponseByQcastId', {
      params: {
        userId,
        qcastId
      }
    });
    return response;
  }catch(err){
    return {
      id: 500,
      msg: err.message,
    }
  }
}

const saveQcastResponseVideoTranscript = async(transcript: SaveTranscriptProps[]) => {
  try {
    const response = await Api.callProtectedApi('POST', '/saveVideoResponseTranscript', {
      data: transcript
    });
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
}

const getResponseVideoTranscript = async (videoId: string) => {
  try {
    const response = await Api.callProtectedApi('GET', '/getVideoResponseTranscript', {
      params: {
        videoId
      }
    });
    return response;
  } catch (err) {
    return {
      id: 500,
      msg: err.message,
    };
  }
};

const QcastApi = {
  getUserDetail,
  updateProfile,
  qcastQuery,
  saveQcast,
  getQcastByIdAndOrganisationApiKey,
  saveResponse,
  updateResponderDetails,
  getQcastBtId,
  getQcastDeepCopy,
  getQcastDeepCopyForPlayer,
  getResponseDeepCopy,
  listQcastsByOrganisationApiKey,
  getPluginMode,
  getQcastResponses,
  getTranscription,
  getResponseVideoTranscript,
  getTranscriptionInterview,
  qcastOrgQuery,
  qcastOrgQuery2
};

export default QcastApi;
